export enum FAMILY_ONBOARDING_CLASSES {
  STEP_1 = 'js-family-onboarding-step-1',
  STEP_2 = 'js-family-onboarding-step-2',
  STEP_3 = 'js-family-onboarding-step-3',
  MOBILE_STEP_1 = 'js-family-onboarding-mobile-step-1',
  MOBILE_STEP_2 = 'js-family-onboarding-mobile-step-2',
  MOBILE_STEP_3 = 'js-family-onboarding-mobile-step-3',
}
